import React from "react";
import { Quote, Star } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

const quotes = [
  {
    text: "They refused to ship anything they wouldn't install on their own phone. That discipline shows in the result.",
    author: "Huy Tran",
    role: "Head of Product, Startup X",
  },
  {
    text: "Most agencies deliver decks. Phuc Pham delivers apps that users open on day 90, not just day 1.",
    author: "Mai Nguyen",
    role: "Founder, Habit Labs",
  },
  {
    text: "Quiet, fast, and deadly serious about craft. Exactly what the pitch said they'd be.",
    author: "Duc Pham",
    role: "CTO, FinEdge",
  },
];

function Testimonials() {
  return (
    <section className="section relative bg-levi-surface border-y border-levi-border overflow-hidden">
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-levi-primary/10 blur-[120px] rounded-full" />
      <div className="container-xl relative">
        <Reveal className="text-center max-w-2xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-levi-primary" />
            <span className="eyebrow">Testimonials</span>
            <span className="h-px w-12 bg-levi-primary" />
          </div>
          <h2 className="display-lg text-levi-text">
            Words from the <span className="text-levi-primary">front lines.</span>
          </h2>
        </Reveal>

        <Stagger className="grid md:grid-cols-3 gap-6">
          {quotes.map((q) => (
            <StaggerItem key={q.author}>
              <figure className="h-full p-8 bg-levi-bg border border-levi-border hover:border-levi-primary transition-colors duration-500">
                <Quote size={28} className="text-levi-primary mb-6" />
                <blockquote className="text-levi-text leading-relaxed mb-6">
                  "{q.text}"
                </blockquote>
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={14} className="fill-levi-accent text-levi-accent" />
                  ))}
                </div>
                <figcaption>
                  <div className="font-display text-lg tracking-wider uppercase text-levi-text">
                    {q.author}
                  </div>
                  <div className="text-sm text-levi-muted">{q.role}</div>
                </figcaption>
              </figure>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}

export default Testimonials;
